/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem, pxToEm, pxToEmWithBaseline, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION : STYLES --------------- ++++++++++ */
export default theme => ({
    ratingsgeneralsection: {
        '& .collapsable.opened': {
            maxHeight: pxToRem(3000)
        },
        '& .sectiongroup': {
            '& .field': {
              maxWidth: pxToEm(345),
              width: '100%'
            }
        },
        '& .name-controls': {
            display: 'flex',
            flexWrap: 'wrap',
            '& .control': {
                maxWidth: pxToEm(172),
                width: '100%',
                marginRight: pxToEm(8),
                [mediaQuery.customizeThinnest]: {
                    marginBottom: pxToEm(8)
                },
                '&.selected-false':{
                    color: '#062b75'
                },
                '&:last-child': {
                    marginRight: 0,
                    [mediaQuery.customizeThinnest]: {
                        marginBottom: 0
                    }
                }
            }
        },
        '& .message': {
            fontWeight: 'normal',
        },
        '& .link.name-learnmore': {
            fontWeight: '500',
            color: theme.color.primary.xlight.contrast
        }
    }
});
